import { isRequiredWithObjEqual, strMax } from '../../utils';
export default {
    other: [
        isRequiredWithObjEqual('その他を入力してください', 'check', true),
        strMax(25, '25文字以内で入力してください'),
    ],
};
